<template>
<div>

<div>
      <b-container>
        <b-form-row>
          <b-col sm>
            <b-row><b-img :src="'data:image/jpeg;base64,' + photo.thumbnail" alt="photo" > </b-img></b-row>
            <b-row><small> {{photo.fileName}} </small>  </b-row>
          </b-col>
          <b-col sm>
             <b-form-group id="group-caption" label="Edit caption:" label-for="input-caption" class="pt-2">
               <b-form-input id="input-caption" v-model="form.caption" placeholder="Enter title of photo..." style="min-width:200px;"  maxlength="100" v-on:input="dirty"> </b-form-input>
             </b-form-group>
             <b-form-group id="group-remarks" label="Edit remarks:" label-for="input-remarks">
               <b-form-textarea id="input-remarks" v-model="form.remarks" rows="4"  maxlength="1000" v-on:input="dirty"> </b-form-textarea>
             </b-form-group>
          </b-col>

          <b-alert variant="danger" v-model="isError"> {{ error }} </b-alert> 

        </b-form-row>

      </b-container>
        
        <div class="text-center">
        <span class="float-left mt-2 ml-2"> <b-button size="sm" class="float-right mr-4" variant="danger"  v-b-tooltip.hover
                title="Permanently remove photo from Journal" v-on:click="remove()">Remove</b-button> </span>

        <b-spinner v-if="isBusy"> </b-spinner>

        <span class="float-right mr-3">
         <b-button v-if="isDirty" v-on:click="save()">Save Changes</b-button>
         <b-button v-if="!isDirty" v-on:click="close()">Close</b-button>  
        </span>

        </div>

  </div>
    
 </div>
</template>

<script>
export default {
  name: 'EditPhoto',
   props: ['photo'],
   data: function() {
    return {
        isDirty: false,
        isBusy: false,
        isError: false,
        error: '',
        form: {
          id: '',
          caption: '',
          remarks: '',
        },
    }

   },
 
    mounted: function() {
     this.form.id = this.photo.id;
     this.form.caption = this.photo.caption;
     this.form.remarks = this.photo.remarks;
  },

   methods: {
       dirty() {
           this.isDirty = true;
       },
       save() {
         this.isBusy = true;
         this.$emit("save", this.form);
       },
       close() {
         this.$emit("close");
       },
       remove() {
         this.isBusy = true;
        this.$emit("remove",this.photo.id);
       }
    
   },

  computed: {

  }
}
</script>

<style scoped>

</style>